import React from 'react';
import PropTypes from 'prop-types';
import HelpButton from '../help-button';
import I18n from '../i18n';
import {Link} from 'react-router-dom';
import Icon from '../icon';
import Tooltip from '../tooltip';

export default function ViewHeading(props) {
  const {title, helpTopic, backTo, children, ...rest} = props;

  return (
    <h1 className="view-heading" {...rest}>
      {backTo && (
        <Tooltip message={I18n.t('action.back')}>
          <Link to={backTo} className="view-back-button">
            <Icon className="fa-fw" iconStyle="fas" icon="angle-left" />
          </Link>
        </Tooltip>
      )}
      <I18n t={title} />
      <span className="view-heading-content">
        {children}
        {helpTopic && <HelpButton topic={helpTopic} />}
      </span>
    </h1>
  );
}

ViewHeading.defaultProps = {};

ViewHeading.propTypes = {
  /** The i18n translation key for the page title. */
  title: PropTypes.string.isRequired,
  /** A help topic for this view. If specified, a help buttonw will be shown on the heading. */
  helpTopic: PropTypes.string,
  /** Optional string. If specified, a back button will be rendered that navigates to this URL. */
  backTo: PropTypes.string,
  /** Child elements to include in the same horizontal space. */
  children: PropTypes.node,
};
